import { ClipboardList, FileText, Link2 } from 'lucide-react';

const formLabel = (f) => f.name || f.file_name || 'Intake form';

/**
 * The forms a client was asked to complete, on their own booking.
 *
 * They used to exist only inside one confirmation email — delete the email and the forms were
 * gone (owner, Jun 2026). Now the booking itself carries them.
 */
export default function IntakeFormsBlock({ forms, testId = 'intake-forms-block', compact = false }) {
  const list = (forms || []).map(f => (typeof f === 'string' ? { name: '', url: f } : f)).filter(f => f?.url);
  if (!list.length) return null;

  return (
    <div
      data-testid={testId}
      style={{
        border: '1px solid rgba(217,179,74,0.4)', background: 'rgba(254,249,234,0.6)',
        borderRadius: 8, padding: compact ? '10px 12px' : '12px 14px', marginTop: 10,
        fontSize: 13, lineHeight: 1.6,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 6 }}>
        <ClipboardList size={14} style={{ opacity: 0.7 }} />
        <strong style={{ fontSize: 12.5 }}>
          {list.length === 1 ? 'Form to complete' : `Forms to complete (${list.length})`}
        </strong>
      </div>
      <ul style={{ margin: 0, paddingLeft: 2, listStyle: 'none' }}>
        {list.map((f, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
            {f.kind === 'file' ? <FileText size={12} style={{ opacity: 0.55, flexShrink: 0 }} />
                               : <Link2 size={12} style={{ opacity: 0.55, flexShrink: 0 }} />}
            <a
              href={f.url}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'underline' }}
              data-testid={`${testId}-link-${i}`}
            >
              {formLabel(f)}
            </a>
            {f.required && (
              <span style={{ fontSize: 10.5, color: '#a33', fontWeight: 600 }}>required</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
